module.exports = "<div class=\"container mt-5 pt-5\" [innerHtml]='myTemplate | safeHtml'></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/landing/info/confidential/confidential.component.html
// module id = ./src/app/landing/info/confidential/confidential.component.html
// module chunks = main